function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';

var withValidation = function withValidation() {
  return [withState('validationErrors', 'setValidationErrors', {}), withHandlers({
    setValidationError: function setValidationError(props) {
      return function (key, error) {
        if (!error) {
          props.setValidationErrors(Object.assign({}, props.validationErrors, _defineProperty({}, key, false)));
        } else {
          props.setValidationErrors(Object.assign({}, props.validationErrors, _defineProperty({}, key, error)));
        }
      };
    }
  })];
};

export default withValidation;